const { Get } = require('../lib/ajax')

document.addEventListener('DOMContentLoaded', function () {
  var elements = document.querySelectorAll(".js-subscribe-button")
  Array.from(elements).forEach(function (element) {
    element.addEventListener("click", function (evt) {
      evt.preventDefault();

      Array.from(elements).forEach(function (e) {
        e.disabled = true
      })

      new Get(this.href, {
        success: function (response) {
          stripe
            .redirectToCheckout({
              sessionId: response.checkoutSessionId,
            })
            .then(function (result) {
              console.log("error");
              // If `redirectToCheckout` fails due to a browser or network
              // error, display the localized error message to your customer
              // using `result.error.message`.
            })
            .catch(function (err) {
              console.log(err);
            });
        }
      })
    });
  })
})
